import axios from "axios";
import { API_URL } from "../constants";

export interface PublicProfile {
  id: string;
  name: string;
  email: string;
  position: string;
  companyPhone: string;
  avatarFileId: string | null;
  lastSeenAt: number | null;
  manager: {
    id: string;
    name: string;
    avatarFileId: string | null;
  } | null;
}

export async function fetchPublicProfile(
  companyId: string,
  userId: string
): Promise<PublicProfile> {
  const res = await axios.get(
    `${API_URL}/${companyId}/users/${userId}/public-profile`
  );
  return res.data.profile as PublicProfile;
}
